import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {curry} from 'ramda';
import wrap from 'wraptile';

import {
    MediaOrderValidationItem,
    MediaOrderImportContainerProps,
    ImportMediaOrderActionParams,
    HandleSubmitHandlers,
    SetStateBoolean,
} from '../MediaOrdersTypes';
import MediaOrderImport from './MediaOrderImport';

export default function MediaOrderImportContainer(props: MediaOrderImportContainerProps) {
    const {
        importMedia,
        setFilter,
        listRowsPerPage,
        setMediaOrderId,
    } = props;
    const history = useHistory();
    const [isValidationsVisible, setValidationsVisible] = useState<boolean>(false);
    const [validations, setValidations] = useState<MediaOrderValidationItem[]>([]);
    const [rowsPerPage, setRowsPerPage] = useState<number>(25);
    const [open, setOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    
    const onPopupClose = handlePopupClose(setValidationsVisible);
    const onClose = handleClose(setOpen);
    const onOpen = handleOpen(setOpen);
    
    const onSubmit = handleSubmit({
        importMedia,
        setLoading,
        listRowsPerPage,
        handleClose: handleClose(setOpen),
        history,
        setFilter,
        setValidations,
        setMediaOrderId,
        setValidationsVisible,
    });
    
    return (
        <MediaOrderImport
            handleClose={onClose}
            handleOpen={onOpen}
            handleSubmit={onSubmit}
            isLoading={isLoading}
            validations={validations}
            handlePopupClose={onPopupClose}
            isValidationsVisible={isValidationsVisible}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            open={open}
        />
    
    );
}

export const handlePopupClose = wrap((setValidationsVisible: SetStateBoolean) => {
    setValidationsVisible(false);
});

export const handleOpen = wrap((setOpen: SetStateBoolean) => {
    setOpen(true);
});

export const handleClose = wrap((setOpen: SetStateBoolean) => {
    setOpen(false);
});

export const createFormData = (file: File): FormData => {
    const formData = new FormData();
    formData.append('file', file, 'xlsx');
    
    return formData;
};

export const handleSubmit = curry(async (actions: HandleSubmitHandlers, files: File[]) => {
    const {
        importMedia,
        setLoading,
        listRowsPerPage,
        handleClose,
        history,
        setFilter,
        setValidations,
        setValidationsVisible,
        setMediaOrderId,
    } = actions;
    
    if (!files.length)
        return null;
    
    setLoading(true);
    
    const [file] = files;
    const formData = createFormData(file);
    
    const params: ImportMediaOrderActionParams = {
        formData,
        listRowsPerPage,
        handleClose,
        history,
        setFilter,
        setValidations,
        setValidationsVisible,
        setMediaOrderId,
    };
    await importMedia(params);
    
    setLoading(false);
});
